<template><div><h1>VUX V2.7.4 发布日志</h1>
<h2><a href="/zh-CN/components/actionsheet.html">Actionsheet</a></h2>
<ul><li>[fix] 修复值为 0 时事件参数为空的问题 #2209</li>
</ul>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[feature] 支持事件 on-confirm on-cancel #2221</li>
</ul>
<h2><a href="/zh-CN/components/tabbar.html">Tabbar</a></h2>
<ul><li>[enhance] 开发模式下对于非 100% 布局使用显示 absolute 定位说明</li>
</ul>
<h2><a href="/zh-CN/components/x-button.html">XButton</a></h2>
<ul><li>[feature] 顺应 iOS 设计，支持直接定义背景渐变 prop:gradients</li>
</ul>
<h2><a href="/zh-CN/components/x-dialog.html">XDialog</a></h2>
<ul><li>[fix] 修复定位为 absolute 导致的定位问题 #2220</li>
</ul>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[fix] 修复服务端渲染 DOM 不一致问题 #2201</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.7.4 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.7.4-262.vue?147fb397